function Hero() {

  return (

    <section id="home" className="hero reveal">

      <img
        src="/images/banner.png"
        className="banner"
        alt="Portfolio Banner"
      />

      <div className="hero-content">

        <h1>
          Banka Lakshmi <br />
          Chaitanya Ram
        </h1>

        <p>
          Computer Science student exploring technology, development,
          3D design and digital creativity.
        </p>

        <a href="#about" className="primary-btn">
          Explore Portfolio
        </a>

      </div>

    </section>

  );

}

export default Hero;